var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcVideosEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B8B7B7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.322 56.604h-4.065l-1.44-1.39c5.042-5.866 8.078-13.482 8.078-21.766C66.895 14.974 51.921 0 33.448 0 14.974 0 0 14.974 0 33.448 0 51.92 14.974 66.895 33.448 66.895c8.284 0 15.9-3.036 21.766-8.079l1.39 1.441v4.065L82.333 90 90 82.333l-25.678-25.73Zm-30.874 0c-12.813 0-23.156-10.343-23.156-23.156 0-12.813 10.343-23.156 23.156-23.156 12.813 0 23.156 10.343 23.156 23.156 0 12.813-10.343 23.156-23.156 23.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.625 23.5h-19.25c-1.765 0-3.208 1.181-3.208 2.625v15.75c0 1.444 1.443 2.625 3.208 2.625h19.25c1.765 0 3.208-1.181 3.208-2.625v-15.75c0-1.444-1.443-2.625-3.208-2.625ZM30.433 39.25v-10.5l7.7 5.25-7.7 5.25Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideosEmpty);
export default __webpack_public_path__ + "static/media/ic_videos_empty.280ae5d229be5582b201947ca6f63a30.svg";
export { ForwardRef as ReactComponent };